import Button from "./Common/Button";

const ZoneGrid = ({
    zones,
    handleSelectZone,
    getTimeForZone,
    handleNavigateToUnits,
    toggleDropdown,
    handleEditClick,
    handleDeletePod,
    handleGenerateReport,
    activeDropdownId,
    dropdownRef,
    isActionsDisabled,
    "data-testid": dataTestId = "zone-grid"
}) => {
    return (
        <div className="mt-4 podsHolder" data-testid={dataTestId}>
            <div className="grid max-[430px]:grid-cols-1 grid-cols-[repeat(auto-fill,minmax(312px,1fr))] gap-6">
                {zones?.map((item, id) => {
                    const cardId = item.unid || id;
                    return (
                    <div className="pods bg-white dark:darkThemeGradiantBg p-4 rounded-lg shadow-appShadow min-h-36" key={item.unid} data-testid={`zone-grid-card-${cardId}`}>
                        <div className="flex flex-col h-full gap-3">
                            <div className="podsBody flex grow cursor-pointer" onClick={() => handleSelectZone(item)} data-testid={`zone-grid-card-body-${cardId}`}>
                                <div className="flex flex-col gap-2 w-full">
                                    <p className="podName text-dark-grey dark:text-white font-semibold text-base leading-5 lg:text-lg lg:leading-7 tracking-[0.27px] truncate block w-full" data-testid={`zone-grid-name-${cardId}`}>
                                        {item.name}
                                    </p>
                                    <div className="flex items-center gap-5 justify-between">
                                        <div className="podLocation flex items-center gap-2">
                                            <div className="iconHolder">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M2.66675 6.76187C2.66675 3.76359 5.05456 1.33301 8.00008 1.33301C10.9456 1.33301 13.3334 3.76359 13.3334 6.76187C13.3334 9.73665 11.6312 13.2079 8.97537 14.4493C8.35625 14.7387 7.64391 14.7387 7.02479 14.4493C4.36896 13.2079 2.66675 9.73665 2.66675 6.76187Z"
                                                        stroke="#292D32"
                                                        className="dark:stroke-theme"
                                                    />
                                                    <circle
                                                        cx="8"
                                                        cy="6.66699"
                                                        r="2"
                                                        stroke="#292D32"
                                                        className="dark:stroke-theme"
                                                    />
                                                </svg>
                                            </div>
                                            <p className="text-dark-grey dark:text-white text-sm leading-6 font-semibold tracking-[0.021px]" data-testid={`zone-grid-city-${cardId}`}>
                                                {typeof item?.cityName === 'string' ? item.cityName.split(',')[0].trim() : ''}
                                            </p>
                                        </div>
                                        <div className="timeHolder flex items-center gap-2">
                                            <div className="iconHolder">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                >
                                                    <g clip-path="url(#clip0_621_2379)">
                                                        <circle
                                                            cx="7.99992"
                                                            cy="7.99967"
                                                            r="6.66667"
                                                            stroke="#1E2A2C"
                                                            className="dark:stroke-theme"
                                                        />
                                                        <path
                                                            d="M8 5.33301V7.99967L9.66667 9.66634"
                                                            stroke="#1E2A2C"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="dark:stroke-theme"
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_621_2379">
                                                            <rect width="16" height="16" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                            <p className="text-dark-grey dark:text-white text-sm leading-6 font-semibold tracking-[0.021px]" data-testid={`zone-grid-time-${cardId}`}>
                                                {getTimeForZone(item.timeZone)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="podsFooter border-t border-[#AFC3BC66] dark:border-darkThemeBorder basis-9">
                                <div className="flex items-center justify-between h-full pt-3">
                                    <div className="timeHolder flex items-center gap-2 cursor-pointer" onClick={() => handleNavigateToUnits(item)} data-testid={`zone-grid-units-count-${cardId}`}>
                                        <div className="unitsCountHolder">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9 10.4587C9 9.20158 9 8.57304 9.39052 8.18252C9.78105 7.79199 10.4096 7.79199 11.6667 7.79199C12.9237 7.79199 13.5523 7.79199 13.9428 8.18252C14.3333 8.57304 14.3333 9.20158 14.3333 10.4587V11.792C14.3333 13.0491 14.3333 13.6776 13.9428 14.0681C13.5523 14.4587 12.9237 14.4587 11.6667 14.4587C10.4096 14.4587 9.78105 14.4587 9.39052 14.0681C9 13.6776 9 13.0491 9 11.792V10.4587Z"
                                                    stroke="#1E2A2C"
                                                    className="dark:stroke-white"
                                                />
                                                <path
                                                    d="M1.3335 5.79199C1.3335 7.04907 1.3335 7.67761 1.72402 8.06813C2.11454 8.45866 2.74308 8.45866 4.00016 8.45866C5.25724 8.45866 5.88578 8.45866 6.27631 8.06813C6.66683 7.67761 6.66683 7.04907 6.66683 5.79199V4.45866C6.66683 3.20158 6.66683 2.57304 6.27631 2.18252C5.88578 1.79199 5.25724 1.79199 4.00016 1.79199C2.74308 1.79199 2.11454 1.79199 1.72402 2.18252C1.3335 2.57304 1.3335 3.20158 1.3335 4.45866V5.79199Z"
                                                    stroke="#1E2A2C"
                                                    className="dark:stroke-white"
                                                />
                                                <path
                                                    d="M9 3.79199C9 3.17074 9 2.86011 9.10149 2.61508C9.23682 2.28838 9.49638 2.02881 9.82309 1.89349C10.0681 1.79199 10.3787 1.79199 11 1.79199H12.3333C12.9546 1.79199 13.2652 1.79199 13.5102 1.89349C13.8369 2.02881 14.0965 2.28838 14.2318 2.61508C14.3333 2.86011 14.3333 3.17074 14.3333 3.79199C14.3333 4.41325 14.3333 4.72388 14.2318 4.9689C14.0965 5.29561 13.8369 5.55517 13.5102 5.6905C13.2652 5.79199 12.9546 5.79199 12.3333 5.79199H11C10.3787 5.79199 10.0681 5.79199 9.82309 5.6905C9.49638 5.55517 9.23682 5.29561 9.10149 4.9689C9 4.72388 9 4.41325 9 3.79199Z"
                                                    stroke="#1E2A2C"
                                                    className="dark:stroke-white"
                                                />
                                                <path
                                                    d="M1.3335 12.458C1.3335 13.0793 1.3335 13.3899 1.43499 13.6349C1.57032 13.9616 1.82988 14.2212 2.15658 14.3565C2.40161 14.458 2.71224 14.458 3.3335 14.458H4.66683C5.28808 14.458 5.59871 14.458 5.84374 14.3565C6.17045 14.2212 6.43001 13.9616 6.56534 13.6349C6.66683 13.3899 6.66683 13.0793 6.66683 12.458C6.66683 11.8368 6.66683 11.5261 6.56534 11.2811C6.43001 10.9544 6.17045 10.6948 5.84374 10.5595C5.59871 10.458 5.28808 10.458 4.66683 10.458H3.3335C2.71224 10.458 2.40161 10.458 2.15658 10.5595C1.82988 10.6948 1.57032 10.9544 1.43499 11.2811C1.3335 11.5261 1.3335 11.8368 1.3335 12.458Z"
                                                    stroke="#1E2A2C"
                                                    className="dark:stroke-white"
                                                />
                                            </svg>
                                        </div>
                                        <p className="text-dark-grey dark:text-white text-sm leading-6 font-semibold tracking-[0.021px]">
                                            {item.unitCount} Units
                                        </p>
                                    </div>
                                    <div className="dropdownHolder relative group">
                                        <Button
                                            className="flex items-center gap-2 text-primaryText font-semibold text-sm leading-6 tracking-[0.021px]"
                                            onClick={() => toggleDropdown(item.unid)}
                                            data-testid={`zone-grid-actions-toggle-${cardId}`}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <circle cx="5" cy="12" r="2" fill="#FF8C65" />
                                                <circle cx="12" cy="12" r="2" fill="#FF8C65" />
                                                <circle cx="19" cy="12" r="2" fill="#FF8C65" />
                                            </svg>
                                        </Button>
                                        {activeDropdownId === item.unid && (
                                            <div className="dropdownContent min-w-32 whitespace-nowrap absolute bottom-full right-0 bg-[#FFF4D1] dark:bg-darkThemeDropdownBg dark:shadow-darkThemeDropdownMenuShadow rounded-lg shadow-appShadow block" ref={dropdownRef} data-testid={`zone-grid-actions-menu-${cardId}`}>
                                                <div className="flex flex-col">
                                                    <Button
                                                        className={`text-dark-grey dark:text-white font-medium text-sm leading-6 cursor-pointer px-3 py-1 rounded border-b border-[#AFC3BC99] dark:border-darkThemeBorder text-left ${
                                                          isActionsDisabled ? "opacity-50 cursor-not-allowed" : ""
                                                        }`}
                                                        onClick={() => handleEditClick(item.unid)}
                                                        disabled={isActionsDisabled}
                                                        data-testid={`zone-grid-edit-button-${cardId}`}
                                                    >
                                                        Edit
                                                    </Button>
                                                    {item.unitCount > 0 && (
                                                        <Button
                                                            className="text-dark-grey dark:text-white font-medium text-sm leading-6 cursor-pointer px-3 py-1 rounded border-b border-[#AFC3BC99] dark:border-darkThemeBorder text-left"
                                                            onClick={() => handleGenerateReport(item)}
                                                            data-testid={`zone-grid-generate-report-button-${cardId}`}
                                                        >
                                                            Generate Report
                                                        </Button>
                                                    )}
                                                    <Button
                                                        className={`text-dark-grey dark:text-white font-medium text-sm leading-6 cursor-pointer px-3 py-1 rounded border-b border-[#AFC3BC99] dark:border-darkThemeBorder text-left ${
                                                          isActionsDisabled ? "opacity-50 cursor-not-allowed" : ""
                                                        }`}
                                                        onClick={() => handleDeletePod(item.unid, item.unitCount)}
                                                        disabled={isActionsDisabled}
                                                        data-testid={`zone-grid-delete-button-${cardId}`}
                                                    >
                                                        Delete
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    );
                })}
            </div>
        </div>
    )
}

export default ZoneGrid;
